import $ from 'jquery';
import StoreLocator from 'store-locator';

import { $Elements, Events, MapTiles } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Simple Map ----------

	$('.simple-map').each(function() {

		let marker = this.dataset.marker;
		marker = (typeof marker === 'string') ? JSON.parse(marker) : marker;

		const map = new StoreLocator({
			stores: marker,
			selectors: {
				map: this.attributes.id.value,
			},
			map: {
				tiles: MapTiles,
				options: {
					maxZoom: 18,
				},
				markers: {
					icon: feature => L.icon({
						iconUrl: feature.properties.icon,
						iconSize: [44, 60],
						iconAnchor: [22, 60],
						popupAnchor: [0, -60],
					}),
				}
			}
		});
	});

});
